import { Button, Tooltip, useTheme } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { FormattedMessage } from 'react-intl';

export default function CenterMapButton({ map, disabled }) {
  const theme = useTheme();
  return (
    <Tooltip
      title={<FormattedMessage id="RECENTER" defaultMessage="Recenter" />}
      arrow>
      <Button
        disabled={disabled}
        variant="contained"
        sx={{
          boxShadow: theme.shadows[4],
          position: 'absolute',
          right: '15px',
          top: '80px',
          backgroundColor: 'background.paper',
          paddingLeft: '10px',
          paddingRight: '10px',
          minWidth: '0px',
          color: 'text.primary',
          ':hover': {
            backgroundColor: 'neutral.default',
          },
          '&.Mui-disabled': {
            opacity: 0.9,
            color: theme.palette.text.disabled,
            backgroundColor: 'background.paper',
          },
        }}
        onClick={() => map.adjustMap()}>
        <MyLocationIcon
          fontSize="small"
          sx={{ marginLeft: '5px', marginRight: '2px' }}
        />
        <FormattedMessage id="CENTER" defaultMessage="Center" />
      </Button>
    </Tooltip>
  );
}
